// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__u-AlI","label":"SetPasswdForm_label__2kBae"};